import { BpdCountryInfo } from '/react4xp/parts/bpd-country-info/bpd-country-info'

export default (props) => <BpdCountryInfo {...props} />
